import { Bar, BarChart, CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts'
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart'

type Series = {
  key: string
  label: string
  color: string
}

export function ReportChart({
  data,
  xKey,
  series,
  type = 'line',
}: {
  data: Record<string, unknown>[]
  xKey: string
  series: Series[]
  type?: 'line' | 'bar'
}) {
  const config = Object.fromEntries(
    series.map((item) => [item.key, { label: item.label, color: item.color }]),
  ) satisfies ChartConfig
  const common = (
    <>
      <CartesianGrid vertical={false} />
      <XAxis dataKey={xKey} tickLine={false} axisLine={false} tickMargin={8} />
      <YAxis tickLine={false} axisLine={false} width={42} />
      <ChartTooltip content={<ChartTooltipContent />} />
    </>
  )

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <ChartContainer config={config} className="h-[320px] w-full">
        {type === 'bar' ? (
          <BarChart data={data}>
            {common}
            {series.map((item) => (
              <Bar
                key={item.key}
                dataKey={item.key}
                fill={`var(--color-${item.key})`}
                radius={[5, 5, 0, 0]}
              />
            ))}
          </BarChart>
        ) : (
          <LineChart data={data}>
            {common}
            {series.map((item) => (
              <Line
                key={item.key}
                type="monotone"
                dataKey={item.key}
                stroke={`var(--color-${item.key})`}
                strokeWidth={2}
                dot={false}
              />
            ))}
          </LineChart>
        )}
      </ChartContainer>
    </div>
  )
}
